import styled from 'styled-components'
import { motion } from 'framer-motion'

export const StyledHomePage = styled(motion.div)``
